import { render, staticRenderFns } from "./portal-login.vue?vue&type=template&id=c8410e28&scoped=true&"
import script from "./portal-login.vue?vue&type=script&lang=js&"
export * from "./portal-login.vue?vue&type=script&lang=js&"
import style0 from "./portal-login.vue?vue&type=style&index=0&id=c8410e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../MultiSiteClient/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8410e28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../MultiSiteClient/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
